import Script from 'next/script';
import { useRef } from 'react';
import { Footer } from 'remote-com-shared/components/Footer';
import { Hero } from 'remote-com-shared/components/Hero';
import HeroContext, { useHeroIntersection } from 'remote-com-shared/components/Hero/context';
import { isDefaultLocaleLanguage } from 'remote-com-shared/domains/locales/helpers';
import styled from 'styled-components';

import { Header } from '@/src/components/Header';
import SiteHeader from '@/src/components/shared/SiteHeader';
import { querySharedServices } from '@/src/domains/shared/services';

// Fake hero so we get some SEO benefits and correct hero behaviour
const FillerHero = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  pointer-events: none;
  z-index: -1;
  opacity: 0;
`;

export default function ReferAFriend() {
  return (
    <div>
      <Script
        src="https://api.aklamio.com/assets/embed/1.latest/embed.min.js"
        strategy="afterInteractive"
      />

      <SiteHeader />
      <FillerHero aria-hidden="true">
        <Hero
          title={
            <>
              Refer a friend <br />
              and get paid!
            </>
          }
          description="Now earn $300 when you refer Remote's EOR services to a friend."
          preview="20vh"
        />
      </FillerHero>
      <div data-aklamio-embed="true" data-uid="1fcf3b8e71662c96a129f4826a2e02fe" />
    </div>
  );
}

export async function getStaticProps({ locale, defaultLocale, previewData = {} }) {
  if (!isDefaultLocaleLanguage(locale, defaultLocale)) {
    return { notFound: true };
  }
  const sharedServices = await querySharedServices({ previewData, locale });
  return {
    props: { sharedServices },
  };
}

const ReferFriendLayout = ({ children, sharedServices }) => {
  const headerRef = useRef();
  const heroIntersection = useHeroIntersection();

  const { footerNavigationSitewide } = sharedServices ?? {};

  return (
    <HeroContext.Provider value={heroIntersection}>
      <Header ref={headerRef} />
      {children}
      <Footer {...footerNavigationSitewide} />
    </HeroContext.Provider>
  );
};

ReferAFriend.Layout = ReferFriendLayout;
